// extracted by mini-css-extract-plugin
export default {"text":"BlogItem_text__5Na99"};